import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { GlobalStyle } from './GlobalStyle';
import { Languages } from './logic/core/models';
import common_en from "./i18n/en.json";
import common_pl from "./i18n/pl.json";
import common_it from "./i18n/it.json";
import common_de from "./i18n/de.json";
import common_ar from "./i18n/ar.json";
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import AppStateProvider from './appSateProvider';
import { getLanguage } from './logic/language/language';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import ToastStateProvider from './components/Toast/toastStateProvider';

i18next.init({
    defaultNS: 'common',
    interpolation: {escapeValue: false},
    lng: getLanguage(),
    react: {
        transSupportBasicHtmlNodes: true,
    },
    resources: {
        [Languages.EN]: {
            common: common_en
        },
        [Languages.PL]: {
            common: common_pl
        },
        [Languages.IT]: {
            common: common_it
        },
        [Languages.DE]: {
            common: common_de
        },
        [Languages.AR]: {
            common: common_ar
        },
    },
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <BrowserRouter>
                <AppStateProvider>
                    <ToastStateProvider>
                        <App/>
                    </ToastStateProvider>
                </AppStateProvider>
                <GlobalStyle/>
            </BrowserRouter>
        </I18nextProvider>
    // </React.StrictMode>
);


// Unregister any previously installed service worker so clients get fresh assets
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
